import { IconButton } from '@mui/material';
import EyeIcon from 'assets/icons/event-eye.svg';

export const EventItemActionButton = ({ onClick }: { onClick: () => void }) => (
  <IconButton
    onClick={onClick}
    sx={{
      width: 43,
      height: 40,
      border: '1px solid #C4CFFF',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <EyeIcon />
  </IconButton>
);
